import loadWysiwyg from "../components/WysiwygEditor";
import loadJobRoleEditor from "../components/job_roles/Edit";

function HydrateComponents(parent: HTMLElement | Document) {
  const editors = document.querySelectorAll(".wysiwyg-editor");
  editors.forEach((el) => {
    loadWysiwyg(el);
  });

  const roleEditor = document.querySelector(".job-role-edit");
  if (roleEditor) {
    loadJobRoleEditor(roleEditor);
  }
}

document.addEventListener("turbo:load", () => {
  HydrateComponents(document);
});

document.addEventListener("turbo:frame-load", function (e) {
  const parent = e.target as HTMLElement;

  if (parent) {
    HydrateComponents(parent);
  }
});
